import { render, staticRenderFns } from "./PageFour.vue?vue&type=template&id=cfc6ccf2&scoped=true"
import script from "./PageFour.vue?vue&type=script&lang=js"
export * from "./PageFour.vue?vue&type=script&lang=js"
import style0 from "./PageFour.vue?vue&type=style&index=0&id=cfc6ccf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc6ccf2",
  null
  
)

export default component.exports